<template>
  <div>
    <div class="row">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="col-lg-12 d-flex justify-content-center">
        <h1>{{ moment().format("MMMM YYYY") }}</h1>
      </div>
      <hr />
      <div class="col-lg-4">
        <h4>
          Select Time:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectTime"
            @change="callData()"
          >
            <el-option
              v-for="option in selects.time"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-4">
        <h4>
          Select Department:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectDept"
            @change="callDepartment()"
            :disabled="dept"
          >
            <el-option
              v-for="option in selects.department"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-4">
        <h4>
          Select Service Area:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectArea"
            @change="callArea()"
            :disabled="area"
          >
            <el-option
              v-for="option in selects.area"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-md-4 d-flex">
        <card>
          <h4 class="card-title">Attendance Summary Percentage</h4>

          <base-progress
            :height=19
            label="Absent"
            :value="summary.absent"
            value-position="right"
            type="magenta"
          />
          <base-progress
            :height=19
            label="Late-In"
            :value="summary.latein"
            value-position="right"
            type="yellow"
          />
          <base-progress
            :height=19
            label="Manpower Availability"
            value-position="right"
            type="green"
            :value="summary.manpower"
          />
        </card>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-md-6 d-flex" v-for="card in statsCards_1" :key="card.id">
            <stats-card
              :title="card.title"
              :icon="card.icon"
              titleSize="font-size: 22px"
              imgStyle="width: 50px"
            >
              <div class="footer-font" slot="footer" v-html="card.footer" style="color:#99e6ff"></div>
            </stats-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import StatsCard from "src/components/Cards/StatsCard";
import { BaseProgress } from "src/components";
import { Select, Option } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import moment from "moment";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart,
    StatsCard,
    BaseProgress,
    Loading,
    Circle8
  },
  data() {
    return {
      socket: null,
      summary: {
        absent: 0,
        latein: 0,
        manpower: 0
      },
      dept: true,
      area:true,
      selects: {
        selectTime: "",
        selectDept: "",
        selectArea: "",
        time: [
          {
            value: "Today",
            label: "Yesterday"
          },
          {
            value: "Weekly",
            label: "Weekly"
          },
          {
            value: "Monthly",
            label: "Monthly"
          },
          {
            value: "Yearly",
            label: "Yearly"
          }
        ],
        department: [
          {
            value: "*",
            label: "All"
          },
          // {
          //   value: "ICWS",
          //   label: "ICWS"
          // }
        ],
        area: [
          {
            value: "*",
            label: "All"
          },
          // {
          //   value: "KL",
          //   label: "KL"
          // }
        ]
      },
      isLoading: true,
      statsCards_1: [
        {
          id: "1",
          title: "0",
          icon: require("@/assets/img/absent.png"),
          footer: "No of Absent"
        },
        {
          id: "2",
          title: "0",
          // subTitle: "Total/Percentage",
          icon: require("@/assets/img/late-in.png"),
          footer: "No of Late-In"
        },
        {
          id: "3",
          title: "0",
          icon: require("@/assets/img/on-time.png"),
          footer: "No of Manpower Availability"
        },
        {
          id: "4",
          title: "0",
          icon: require("@/assets/img/work-schedule.png"),
          footer: "No of Requirement"
        }
      ]
    };
  },

  methods: {
    parseData(summary){
      this.dept = false
      console.log(summary)
      console.log(parseInt(summary.absent))
      console.log(summary.requirement)
      // arrange data
      this.summary.absent = parseFloat(((summary.absent / summary.requirement) * 100).toFixed(2))
      this.summary.latein = parseFloat(((summary.late / summary.requirement) * 100).toFixed(2))
      this.summary.manpower = parseFloat(((summary.manpower / summary.requirement) * 100).toFixed(2))

      // catch nan value
      if(summary.requirement == 0){
        this.summary.absent = 0
        this.summary.latein = 0
        this.summary.manpower = 0
      }
      console.log(this.summary.absent, this.summary.latein, this.summary.manpower)
      
      this.statsCards_1[0].title = JSON.stringify(summary.absent)
      this.statsCards_1[1].title = JSON.stringify(summary.late)
      this.statsCards_1[2].title = JSON.stringify(summary.manpower)
      this.statsCards_1[3].title = JSON.stringify(summary.requirement)

      console.log(this.statsCards_1[0].title)
      console.log(this.statsCards_1[1].title)
      console.log(this.statsCards_1[2].title)
      console.log(this.statsCards_1[3].title)

      // this.socket.close();
      this.isLoading = false;
      // arrange department filter
      this.selects.department = []
      this.selects.area = []

      //####default value########
      let all  = {
        value: "*",
        label: "All"
      }
      this.selects.department.push(all)
      this.selects.area.push(all)

      
      let dept = summary.department
      let area = summary.serviceArea

      console.log(dept.length)
      console.log(area)
      
      for(var i=0; i<dept.length; i++){
        let obj  = {
          value: dept[i].DeptID,
          label: dept[i].DeptName
        }
        console.log(obj)
        this.selects.department.push(obj)
      }

      for(var i=0; i<area.length; i++){
        let obj  = {
          value: area[i].ServiceAreaID,
          label: area[i].ServiceAreaName
        }
        console.log(obj)
        this.selects.area.push(obj)
      }
    },
    parseData2(summary){
      this.area = false
      console.log(summary)
      console.log(parseInt(summary.absent))
      console.log(summary.requirement)
      // arrange data
      this.summary.absent = parseFloat(((summary.absent / summary.requirement) * 100).toFixed(2))
      this.summary.latein = parseFloat(((summary.late / summary.requirement) * 100).toFixed(2))
      this.summary.manpower = parseFloat(((summary.manpower / summary.requirement) * 100).toFixed(2))

      // catch nan value
      if(summary.requirement == 0){
        this.summary.absent = 0
        this.summary.latein = 0
        this.summary.manpower = 0
      }
      console.log(this.summary.absent, this.summary.latein, this.summary.manpower)
      
      this.statsCards_1[0].title = JSON.stringify(summary.absent)
      this.statsCards_1[1].title = JSON.stringify(summary.late)
      this.statsCards_1[2].title = JSON.stringify(summary.manpower)
      this.statsCards_1[3].title = JSON.stringify(summary.requirement)

      console.log(this.statsCards_1[0].title)
      console.log(this.statsCards_1[1].title)
      console.log(this.statsCards_1[2].title)
      console.log(this.statsCards_1[3].title)

      this.isLoading = false;
      // this.socket.close();

      // arrange department filter
      this.selects.area = []

      //####default value########
      let all  = {
        value: "*",
        label: "All"
      }
      this.selects.area.push(all)
      
      // let dept = summary.filter[0]
      for(var i=0; i<summary.serviceArea.length; i++){
        let obj  = {
          value: summary.serviceArea[i].ServiceAreaID,
          label: summary.serviceArea[i].ServiceAreaName
        }
        console.log(obj)
        this.selects.area.push(obj)
      }
    },
    parseData3(summary){
      console.log(summary)
      console.log(parseInt(summary.absent))
      console.log(summary.requirement)
      
      // arrange data
      this.summary.absent = parseFloat(((summary.absent / summary.requirement) * 100).toFixed(2))
      this.summary.latein = parseFloat(((summary.late / summary.requirement) * 100).toFixed(2))
      this.summary.manpower = parseFloat(((summary.manpower / summary.requirement) * 100).toFixed(2))

      // catch nan value
      if(summary.requirement == 0){
        this.summary.absent = 0
        this.summary.latein = 0
        this.summary.manpower = 0
      }
      console.log(this.summary.absent, this.summary.latein, this.summary.manpower)
      
      this.statsCards_1[0].title = JSON.stringify(summary.absent)
      this.statsCards_1[1].title = JSON.stringify(summary.late)
      this.statsCards_1[2].title = JSON.stringify(summary.manpower)
      this.statsCards_1[3].title = JSON.stringify(summary.requirement)
      
      console.log(this.statsCards_1[0].title)
      console.log(this.statsCards_1[1].title)
      console.log(this.statsCards_1[2].title)
      console.log(this.statsCards_1[3].title)
      console.log(this.statsCards_1)
      this.isLoading = false
      // this.socket.close();
      
    },
    callWebsocket(){
      let startdate = ""
      if(this.selects.selectTime == "Today"){
        // yesterday date
        startdate = moment().subtract(1,'days').unix()
      } else if (this.selects.selectTime == "Weekly"){
        startdate = moment().startOf('isoWeek').unix()
      } else if (this.selects.selectTime == "Monthly"){
        startdate = moment().startOf('month').unix()
      } else {
        startdate = moment().startOf('year').unix()
      }
      console.log(startdate)

      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws"
      );
      console.log(process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws")
      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let currentFilter = [
          startdate,
          this.selects.selectDept,
          this.selects.selectArea
        ];
        console.log(currentFilter)
        this.socket.send(currentFilter);
        
        this.isLoading = true;
      };
      
      this.socket.onmessage = ({ data }) => {
        // console.log(JSON.parse(data))
        this.parseData(JSON.parse(data));
      };
      return this.socket;
    },
    callData(){
      this.socket.close();
      console.log(this.selects.selectTime)
      console.log(this.selects.selectDept)
      console.log(this.selects.selectArea)
      this.selects.selectDept = "*"
      this.selects.selectArea = "*"

      // convert time to timestamp
      let startdate = ""
      if(this.selects.selectTime == "Today"){
        startdate = moment().subtract(1,'days').unix()
      } else if (this.selects.selectTime == "Weekly"){
        startdate = moment().startOf('isoWeek').unix()
      } else if (this.selects.selectTime == "Monthly"){
        startdate = moment().startOf('month').unix()
      } else {
        startdate = moment().startOf('year').unix()
      }
      console.log(startdate)

      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws"
      );
      console.log(process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws")
      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let currentFilter = [
          startdate,
          this.selects.selectDept,
          this.selects.selectArea
        ];
        console.log(currentFilter)
        this.socket.send(currentFilter);
        
        this.isLoading = true;
      };
      
      this.socket.onmessage = ({ data }) => {
        console.log(JSON.parse(data))
        this.parseData(JSON.parse(data));
      };
      return this.socket;
    },
    callDepartment(){
      this.socket.close()
      console.log(this.selects.selectTime)
      console.log(this.selects.selectDept)
      console.log(this.selects.selectArea)

      // convert time to timestamp
      let startdate = ""
      if(this.selects.selectTime == "Today"){
        startdate = moment().subtract(1,'days').unix()
      } else if (this.selects.selectTime == "Weekly"){
        startdate = moment().startOf('isoWeek').unix()
      } else if (this.selects.selectTime == "Monthly"){
        startdate = moment().startOf('month').unix()
      } else {
        startdate = moment().startOf('year').unix()
      }
      console.log(startdate)

      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws"
      );
      console.log(process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws")
      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let currentFilter = [
          startdate,
          this.selects.selectDept,
          this.selects.selectArea
        ];
        console.log(currentFilter)
        this.socket.send(currentFilter);
        
        this.isLoading = true;
      };
      
      this.socket.onmessage = ({ data }) => {
        console.log(JSON.parse(data))
        this.parseData2(JSON.parse(data));
      };
      return this.socket;
    },
    callArea(){
      this.socket.close()
      console.log(this.selects.selectTime)
      console.log(this.selects.selectDept)
      console.log(this.selects.selectArea)

      // convert time to timestamp
      let startdate = ""
      if(this.selects.selectTime == "Today"){
        startdate = moment().subtract(1,'days').unix()
      } else if (this.selects.selectTime == "Weekly"){
        startdate = moment().startOf('isoWeek').unix()
      } else if (this.selects.selectTime == "Monthly"){
        startdate = moment().startOf('month').unix()
      } else {
        startdate = moment().startOf('year').unix()
      }
      console.log(startdate)

      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws"
      );
      console.log(process.env.VUE_APP_WS_URL + ":9995/api/v1/overview/ADMIN_VIEW/ws")
      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let currentFilter = [
          startdate,
          this.selects.selectDept,
          this.selects.selectArea
        ];
        console.log(currentFilter)
        this.socket.send(currentFilter);
        
        this.isLoading = true;
      };
      
      this.socket.onmessage = ({ data }) => {
        console.log(JSON.parse(data))
        this.parseData3(JSON.parse(data));
      };
      return this.socket;
    }
  },
  mounted() {
    console.log(window.scrollY)
    console.log(window.scrollX)
    console.log(window.scrollbars)
  },
  created(){
    this.selects.selectTime =  this.selects.time[0].value
    this.selects.selectDept = this.selects.department[0].value
    this.selects.selectArea = this.selects.area[0].value
    console.log(this.selects.selectTime, this.selects.selectDept, this.selects.selectArea)
    this.callWebsocket()
    // this.socket.close()
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    console.log(this.socket)
    this.socket.close();
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 105%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
</style>
